import {
  createAsyncThunk,
  createSelector,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import * as api from "../api";
import { RootState } from "../store";

interface SelectItem {
  label: string;
  value: string;
}

type User = {
  login: string;
  name: string;
  surname: string;
};
type Config = {
  apiEndpoint: string;
  apiPDFEndpoint: string;
  apiPostalCodesAndModelsEndpoint: string;
};
export type FormState = {
  countries: Array<{ label: string; value: string }>;
  user: User;
  config: Config;
};

const initialState: FormState = {
  countries: [],
  config: {
    apiEndpoint: "",
    apiPDFEndpoint: "",
    apiPostalCodesAndModelsEndpoint: "",
  },
  user: {
    login: "",
    name: "",
    surname: "",
  },
};

export const loadAppData = createAsyncThunk<FormState>(
  "appData/fetch",
  async () => {
    const data = await api.loadAppData();
    return data;
  }
);

const appData = createSlice({
  name: "appData",
  initialState,
  reducers: {
    setUserData(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAppData.fulfilled, (state, { payload }) => {
      state.countries = payload.countries;
      state.config = payload.config;
    });
  },
});

const selectState = (state: RootState) => state.appData;

export const { setUserData } = appData.actions;

export const selectCountries = createSelector(
  selectState,
  (state) => state.countries
);

export const selectUserData = createSelector(
  selectState,
  (state) => state.user
);

export const selectLoggedUser = createSelector(
  selectState,
  (state) => state.user.login
);

export const selectApiConfig = createSelector(
  selectState,
  (state) => state.config
);

export const { reducer } = appData;
